import classNames from 'classnames';
import React from 'react';
import { PiHouseSimpleLight, PiListMagnifyingGlassLight } from 'react-icons/pi';
import { useLocation, useRouteMatch } from 'react-router-dom';

import css from './MobileBottomNavigation.module.css';
import { IconHeart, IconNoldrobe, IconPlus } from 'assets/icons';
import NamedLink from 'components/NamedLink/NamedLink';
import { ProfileTab } from 'containers/ProfilePage/ProfilePage';
import { useCurrentUser } from 'hooks/selectors/useCurrentUser';
import { getPath } from 'util/routes';

const MobileBottomNavigation: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { currentUser } = useCurrentUser();
  const userUuid = currentUser?.id?.uuid;
  const userHandle = currentUser?.attributes?.profile?.publicData?.handle || '';

  const match = useRouteMatch();
  const location = useLocation();

  return (
    <div className={classNames(css.root, className)}>
      <div className={css.content}>
        <NamedLink name="LandingPage" className={css.menuItem}>
          <PiHouseSimpleLight size={22} color="black" />
          <span>Home</span>
        </NamedLink>
        <NamedLink name="MobileSearchPage" className={css.menuItem}>
          <PiListMagnifyingGlassLight size={22} color="black" />
          <span>Shop</span>
        </NamedLink>
        <NamedLink name="ResellLandingPage" className={css.menuItemCenter}>
          <div>
            <IconPlus />
          </div>
        </NamedLink>
        <NamedLink
          name={userUuid ? (userHandle ? 'ProfilePageWithHandle' : 'ProfilePage') : 'LoginPage'}
          params={userUuid ? (userHandle ? { handle: userHandle } : { id: userUuid }) : undefined}
          className={css.menuItem}
          to={userUuid ? { search: `profileTab=${ProfileTab.LISTINGS}` } : undefined}
          active={(() => {
            const pathname = getPath(
              userUuid ? (userHandle ? 'ProfilePageWithHandle' : 'ProfilePage') : 'LoginPage',
              userUuid ? (userHandle ? { handle: userHandle } : { id: userUuid }) : undefined
            );
            const active = match.url && match.url === pathname;
            const profileTab = new URLSearchParams(location.search).get('profileTab');
            return Boolean(active && profileTab === ProfileTab.LISTINGS);
          })()}
        >
          <IconNoldrobe />
          <span>ME</span>
        </NamedLink>
        <NamedLink
          name={userUuid ? (userHandle ? 'ProfilePageWithHandle' : 'ProfilePage') : 'LoginPage'}
          params={userUuid ? (userHandle ? { handle: userHandle } : { id: userUuid }) : undefined}
          className={css.menuItem}
          to={userUuid ? { search: `profileTab=${ProfileTab.FAVOURITES}` } : undefined}
          active={(() => {
            const pathname = getPath(
              userUuid ? (userHandle ? 'ProfilePageWithHandle' : 'ProfilePage') : 'LoginPage',
              userUuid ? (userHandle ? { handle: userHandle } : { id: userUuid }) : undefined
            );
            const active = match.url && match.url === pathname;
            const profileTab = new URLSearchParams(location.search).get('profileTab');
            return Boolean(active && profileTab === ProfileTab.FAVOURITES);
          })()}
        >
          <IconHeart />
          <span>Wishlist</span>
        </NamedLink>
      </div>
    </div>
  );
};

export default MobileBottomNavigation;
